import template from './homeLoanCommissions.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    commission: '<',
    commissions: '<',
    products: '<',
    ticketOwner: '<',
    ticketPartners: '<',
    ticketAccountsAsPartners: '<',
    validationErrors: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $q,
      $rootScope,
      $mdUtil,
      $mdMedia,
      commissionService,
      organizationsService,
      accountsService,
      partnersService,
      helperService,
      homeLoanService,
      ACCOUNT
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganizationRoot = null;
      ctrl.currentOrganizationGroup = null;
      ctrl.currentOrganization = null;
      ctrl.currentTicketOwner = null;
      ctrl.currentAccount = null;
      ctrl.currentDateFormat = null;
      ctrl.currentCurrency = null;
      ctrl.organizationCountry = '';
      ctrl.preferredProduct = null;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.currentAccount = $rootScope.CurrentAccount;
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.validationErrors = ctrl.validationErrors || [];
        const partners = _.uniq(ctrl.ticketPartners);
        const accountsAsPartners = _.uniq(ctrl.ticketAccountsAsPartners);
        $q.all([
          organizationsService.getRoot(),
          organizationsService.getGroup(),
          partners?.length
            ? partnersService.getSpecific({
                ids: partners,
                isActive: true,
                fields: ACCOUNT.FIELDS.CHIPS
              })
            : [],
          accountsAsPartners?.length
            ? accountsService.getSpecific({
                ids: accountsAsPartners,
                isActive: true,
                fields: ACCOUNT.FIELDS.CHIPS
              })
            : []
        ]).then((data) => {
          const currentOrganizationRoot = data[0][0];
          const currentOrganizationGroup = data[1][0];
          ctrl.currentOrganizationRoot = currentOrganizationRoot;
          ctrl.currentOrganizationGroup = currentOrganizationGroup;
          ctrl.currentTicketOwner = ctrl.ticketOwner;
          ctrl.currentTicketPartners = [];
          if (data[2]?.length) {
            ctrl.ticketPartners.forEach((id) => {
              const partner = _.find(data[2], (p) => p.id === id);
              ctrl.currentTicketPartners.push(partner);
            });
          }
          ctrl.currentTicketAccountsAsPartners = [];
          if (data[3]?.length) {
            ctrl.ticketAccountsAsPartners.forEach((id) => {
              const accountAsPartner = _.find(data[3], (p) => p.id === id);
              ctrl.currentTicketAccountsAsPartners.push(accountAsPartner);
            });
          }
          ctrl.organizationCountry = helperService.getOrganizationCountry().name;
          ctrl.preferredProduct = homeLoanService.getPreferredProduct(ctrl.products);
          ctrl.commission = ctrl.commission || {};
          ctrl.commissions = ctrl.commissions || [];
          ctrl.isTicketSettled = ctrl.isTicketSettled || false;
          if (!ctrl.isTicketSettled) {
            ctrl.setCommission();
          } else {
            ctrl.isReady = true;
          }
        });
      };

      ctrl.isCommissionSplitsViewAllowed = () =>
        ctrl.currentAccount.isAdministrator ||
        ctrl.currentOrganization.permissions.usersCanSeeCommissionSplits;

      ctrl.setCommission = () => {
        if (!ctrl.commission?.isEdited) {
          ctrl.commission.commissionSplits = [];
          const commission = _.find(
            ctrl.commissions || [],
            (c) => c?.id === ctrl.commission?.idCommission
          );
          if (commission?.id) {
            ctrl.commission.commissionSplits = commissionService.mergeGenerics(
              commission.splits,
              ctrl.currentOrganizationRoot,
              ctrl.currentOrganizationGroup,
              ctrl.currentOrganization,
              ctrl.currentTicketOwner,
              ctrl.currentTicketPartners,
              ctrl.currentTicketAccountsAsPartners
            );
            ctrl.commission = homeLoanService.setCommission({
              commission: ctrl.commission,
              preferredProduct: ctrl.preferredProduct || {},
              lenderAccreditations: ctrl.ticketOwner?.lenderAccreditations || [],
              commissions: ctrl.commissions || [],
              isInitial: ctrl.commission?.idCommission === ''
            });
          }
        }
        ctrl.isReady = true;
        ctrl.saveHomeLoanCommission();
      };

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.saveHomeLoanCommission = _.debounce(() => {
        ctrl.onFinished({ commission: ctrl.commission });
      }, 2000);

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
